import { AuthzBasicGuard } from "./authz-basic-guard";
import { AuthGuard } from "./auth.guard";
import { AuthzGuard } from "./authz.guard";

export const guards: any[] = [AuthGuard, AuthzBasicGuard, AuthzGuard];

export * from "./auth.guard";
export * from "./authz-basic-guard";
export * from "./authz.guard";
